import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'gold' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  as?: 'button' | 'a';
  href?: string;
}
export function Button({
  variant = 'primary',
  size = 'md',
  as = 'button',
  href,
  className = '',
  children,
  ...rest
}: ButtonProps) {
  const base = 'inline-flex items-center justify-center gap-2 font-medium rounded-full transition-all duration-200 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-forest-700';
  const variants = {
    primary: 'bg-forest-700 text-ivory hover:bg-forest-800 shadow-soft',
    secondary: 'border border-forest-700 text-forest-700 bg-transparent hover:bg-forest-700 hover:text-ivory',
    gold: 'bg-sand-300 text-ink-900 hover:bg-sand-400 shadow-soft',
    ghost: 'text-forest-700 hover:bg-sage-100'
  };
  const sizes = {
    sm: 'text-sm px-4 py-2',
    md: 'text-[15px] px-5 py-2.5',
    lg: 'text-base px-7 py-3.5'
  };
  const cls = `${base} ${variants[variant]} ${sizes[size]} ${className}`;
  if (as === 'a') {
    return <a href={href} className={cls} data-id="element-750" data-mp="er7e1j5xrq80">
        {children}
      </a>;
  }
  return <button className={cls} {...rest} data-id="element-751" data-mp="tnyjoa67dy62">
      {children}
    </button>;
}